export default __webpack_public_path__ + "images/f2e8762e6a8566b902c7c2d77ff13d99.png";